import React from 'react';

function RegisterSuccess(): React.ReactElement {
  return (
    <div
      style={{
        margin: 'auto',
        justifyContent: 'center',
        justifyItems: 'center',
        padding: '10px',
        width: '50%',
        minWidth: '500px',
        textAlign: 'center',
        display: 'flex',
        minHeight: '500px',
        flexDirection: 'column',
      }}
    >
      <h3>Thank you for your interest in CareMappr</h3>
      <br></br>
      <div>
        <p>
          Your registration details have been shared with an CareMappr admin and
          you will be approved access soon.
        </p>
        <p>
          Please contact your supervisor or the CareMappr support team for
          updates.
        </p>
      </div>
    </div>
  );
}

export { RegisterSuccess };
